export enum Rank {
  ACE = 'A',
  DEUCE = '2',
  TREY = '3',
  FOUR = '4',
  FIVE = '5',
  SIX = '6',
  SEVEN = '7',
  EIGHT = '8',
  NINE = '9',
  TEN = 'T',
  JACK = 'J',
  QUEEN = 'Q',
  KING = 'K',
  UNKNOWN = '?',
}

export enum Suit {
  CLUB = 'c',
  DIAMOND = 'd',
  HEART = 'h',
  SPADE = 's',
  UNKNOWN = '?',
}

export type CardString = `${Rank}${Suit}`;
